import {
  ReturnsExclusionsMessage,
  returnsExclusionsMessages,
} from "../messaging";

export const getReturnsExclusionsMessage = (
  browsePageHierarchy: Array<{ categoryId: string }>,
): ReturnsExclusionsMessage | undefined => {
  if (!browsePageHierarchy) return;
  const result = returnsExclusionsMessages.find((returnsExclusionsMessage) => {
    const matchedMessages = returnsExclusionsMessage.categories.filter(
      (returnsExclusionsMessageCategory) =>
        browsePageHierarchy.find(
          (hierarchyItem) =>
            hierarchyItem.categoryId === returnsExclusionsMessageCategory,
        ),
    );
    return matchedMessages.length > 0;
  });
  return result;
};
